import { useEffect, useState } from 'react';

interface WvcLogoProps {
  className?: string;
  style?: React.CSSProperties;
}

declare const wvcClient:
  | { getLogo?: () => Promise<{ attachment_id: number; url: string } | null> }
  | undefined;

async function fetchSvgFromUrl(url: string): Promise<string | null> {
  try {
    const res = await fetch(url);
    if (!res.ok) return null;
    const svg = await res.text();
    return svg.replace(/\bfill="[^"]*"/g, 'fill="currentColor"');
  } catch {
    return null;
  }
}

export function WvcLogo({ className, style }: WvcLogoProps) {
  const [svgContent, setSvgContent] = useState<string | null>(null);

  useEffect(() => {
    if (typeof wvcClient?.getLogo !== 'function') return;

    // Fetch SVG on mount — getLogo() returns cached data instantly on first load,
    // falls back to REST if not pre-loaded
    wvcClient.getLogo().then((meta) => {
      if (meta?.url) fetchSvgFromUrl(meta.url).then((svg) => {
        if (svg) setSvgContent(svg);
      });
    });

    // Re-fetch when WordPress updates the logo
    const handleRefresh = () => {
      wvcClient?.getLogo?.()?.then((updated) => {
        if (updated?.url) fetchSvgFromUrl(updated.url).then((svg) => {
          if (svg) setSvgContent(svg);
        });
      });
    };
    window.addEventListener('WVC_LOGO_REFRESH', handleRefresh);
    return () => window.removeEventListener('WVC_LOGO_REFRESH', handleRefresh);
  }, []);

  if (!svgContent) return null;

  return (
    <span className={className} style={style}>
      <span
        style={{ color: 'var(--color-logo)', display: 'contents' }}
        dangerouslySetInnerHTML={{ __html: svgContent }}
      />
    </span>
  );
}
